// src/pages/public/Home/HomePage.jsx
import React, { useEffect } from "react";
import {
  useAppDispatch,
  useAppSelector,
} from "../../../hooks/useAppDispatch.js";
import { fetchPageBySlug } from "../../../redux/slices/cmsSlice.js";
import { fetchCaseStudies } from "../../../redux/slices/caseStudiesSlice.js";
import { fetchTestimonials } from "../../../redux/slices/testimonialsSlice.js";
import { fetchWebinars } from "../../../redux/slices/webinarsSlice.js";
import { fetchBlogs } from "../../../redux/slices/blogsSlice.js";
import SEO from "../../../components/seo/SEO.jsx";
import HomeHero from "../../../components/sections/HomeHero.jsx";
import WhoWeAre from "../../../components/sections/WhoWeAre.jsx";
import HomeGlobalLeaders from "../../../components/sections/HomeGlobalLeaders.jsx";
import HomeAboutSnippet from "../../../components/sections/HomeAboutSnippet.jsx";
import HomeChallengesPreview from "../../../components/sections/HomeChallengesPreview.jsx";
import HomeTabsSection from "../../../components/sections/HomeTabsSection.jsx";
import HomeFeatureCards from "../../../components/sections/HomeFeatureCards.jsx";
import HomeUpcomingWebinars from "../../../components/sections/HomeUpcomingWebinars.jsx";
import HomeTailoredSolutions from "../../../components/sections/HomeTailoredSolutions.jsx";
import HomeTestimonials from "../../../components/sections/HomeTestimonials.jsx";
import HomeBlogsPreview from "../../../components/sections/HomeBlogsPreview.jsx";
import BuildSolution from "../../../components/common/Common/BuildSolution/BuildSolution.jsx";
import TestimonialsCarousel from "../../../components/sections/TestimonialsCarousel.jsx";
import EngineeringIntelligence from "../../../components/sections/EngineeringIntelligence.jsx";
import Awards from "../../../components/sections/Awards.jsx";

export default function HomePage() {
  const dispatch = useAppDispatch();
  const { currentPage: homePage, loading: pageLoading } = useAppSelector(
    (state) => state.cms,
  );

  useEffect(() => {
    // Fetch home page data
    dispatch(fetchPageBySlug("home"));

    // Fetch data for various sections
    dispatch(fetchCaseStudies({ limit: 4 }));
    // dispatch(fetchTestimonials({ limit: 10 }))
    dispatch(fetchWebinars({ upcoming: true, limit: 2 }));
    dispatch(fetchBlogs({ limit: 2 }));
  }, [dispatch]);

  const getSectionData = (sectionKey) => {
    return homePage?.sections?.find((section) => section.key === sectionKey)
      ?.data;
  };

  const getSectionVisibility = (sectionKey) => {
    return homePage?.sections?.find((section) => section.key === sectionKey)
      ?.isVisible;
  };

  if (pageLoading && !homePage) {
    return (
      <>
        <SEO />
        <div className="space-y-20">
          {/* Skeleton for all sections */}
          {[...Array(10)].map((_, i) => (
            <div key={i} className="container-custom">
              <div className="h-8 bg-black-200 rounded w-1/3 mb-8 animate-pulse"></div>
              <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
                {[...Array(3)].map((_, j) => (
                  <div key={j} className="animate-pulse">
                    <div className="h-48 bg-black-200 rounded-lg mb-4"></div>
                    <div className="h-6 bg-black-200 rounded w-3/4 mb-2"></div>
                    <div className="h-4 bg-black-200 rounded w-1/2"></div>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>
      </>
    );
  }

  return (
    <>
      <SEO title={homePage?.seoTitle} description={homePage?.seoDescription} />

      <div className="space-y-0">
        {/* Hero Section */}
        {getSectionVisibility("hero") && (
          <HomeHero sectionData={getSectionData("hero")} />
        )}

        {/* Who We Are & Cards Section */}
        <WhoWeAre />

        <EngineeringIntelligence />

        {getSectionVisibility("challenges") && (
          <HomeChallengesPreview sectionData={getSectionData("challenges")} />
        )}

        {/* Tabs Section */}
        {/* {getSectionVisibility("tabsSection") && (
          <HomeTabsSection sectionData={getSectionData("tabsSection")} />
        )} */}

        {/* Supersection: 360 Engineering & Webinars */}
        <div style={{ backgroundColor: "white" }}>
          {/* Feature Cards */}
          {/* {getSectionVisibility("featureCards") && (
            <HomeFeatureCards sectionData={getSectionData("featureCards")} />
          )} */}

          {/* Upcoming Webinars */}
        </div>

        {/* Tailored Solutions */}
        {getSectionVisibility("tailoredSolutions") && (
          <HomeTailoredSolutions
            sectionData={getSectionData("tailoredSolutions")}
          />
        )}

        {/* <Awards /> */}

        {/* {getSectionVisibility("upcomingWebinars") && (
          <HomeUpcomingWebinars
            sectionData={getSectionData("upcomingWebinars")}
          />
        )} */}

        {/* <TestimonialsCarousel /> */}

        {/* Blogs Preview */}
        {getSectionVisibility("blogs") && (
          <HomeBlogsPreview sectionData={getSectionData("blogs")} />
        )}
      </div>
    </>
  );
}
